import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import { GetServerSideProps } from 'next';
import { GET } from 'src/services';
import { timestamp } from 'src/utils/helper';
import styled from 'styled-components';
import SectionOne from 'src/components/sections/section-events/shallwesleep/section-one';
import dynamic from 'next/dynamic';
import SectionTwo from 'src/components/sections/section-events/shallwesleep/section-two';
import Footer from 'src/components/sections/section-events/shallwesleep/footer';
import SectionThree from 'src/components/sections/section-events/shallwesleep/section-three';
import SectionFour from 'src/components/sections/section-events/shallwesleep/section-four';
import SectionFive from 'src/components/sections/section-events/shallwesleep/section-five';
import SectionSix from 'src/components/sections/section-events/shallwesleep/section-six';
import { useRef } from 'react';

const PageError = dynamic(import('pages/404'));

function pageShallWeSleep(props: any) {
  if (isEmpty(props?.sectionOne)) return <PageError sessionSevId={null} />;
  const refExclusive = useRef<any>(null);
  const handleRefExclusive = () => {
    refExclusive.current?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <PageWrapper className='section-shall-we-sleep'>
      {!isEmpty(props?.sectionOne) ? <SectionOne data={props?.sectionOne} /> : null}
      {!isEmpty(props?.sectionTwo) ? <SectionTwo data={props?.sectionTwo} /> : null}
      {!isEmpty(props?.sectionThree) ? <SectionThree dataSet={props?.sectionThree} handleRefExclusive={handleRefExclusive} /> : null}
      {!isEmpty(props?.sectionFour)
        ? (
        <div ref={refExclusive}>
          <SectionFour dataSet={props?.sectionFour} />
        </div>
          )
        : null}
      {!isEmpty(props?.sectionFive) && !isEmpty(props?.sectionFiveArticle) ? <SectionFive data={props?.sectionFiveArticle} dataSet={props?.sectionFive} /> : null}
      {!isEmpty(props?.sectionSix) ? <SectionSix dataSet={props?.sectionSix} /> : null}
      <Footer />
    </PageWrapper>
  );
}
const PageWrapper = styled.div`
  width: 100%;
  position: relative;
`;
export const getServerSideProps: GetServerSideProps = async () => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    sectionOne: [],
    sectionTwo: [],
    sectionThree: [],
    sectionFour: [],
    sectionFive: [],
    sectionSix: [],
    sectionFiveArticle: []
  };
  try {
    const fetchDataSet = await GET('/api/datasets');
    if (!isEmpty(fetchDataSet)) {
      const dataSetFive = find(fetchDataSet, { topic: 'section-shallSleep-5' })?.dataSet || [];
      initProps.sectionOne = find(fetchDataSet, { topic: 'section-shallSleep-1' })?.dataSet || [];
      initProps.sectionTwo = find(fetchDataSet, { topic: 'section-shallSleep-2' })?.dataSet || [];
      initProps.sectionThree = find(fetchDataSet, { topic: 'section-shallSleep-3' })?.dataSet || [];
      initProps.sectionFour = find(fetchDataSet, { topic: 'section-shallSleep-4' })?.dataSet || [];
      initProps.sectionFive = dataSetFive;
      initProps.sectionSix = find(fetchDataSet, { topic: 'section-shallSleep-6' })?.dataSet || [];
      if (!isEmpty(find(dataSetFive, { key: 'tag' })?.value)) {
        const fetchData = await GET(`/api/search/tag?name=${find(dataSetFive, { key: 'tag' })?.value}`);
        // const fetchData = await GET('/api/search/tag?name=การเมือง');
        if (!isEmpty(fetchData)) {
          initProps.sectionFiveArticle = fetchData || [];
        }
      }
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> PAGE_CHALIANG ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default pageShallWeSleep;
